<header class="header">
  <h3 class="header-title">
    Como funciona o processo de solicitação de antecipação de notas fiscais de
    serviço
  </h3>
  <img
    src="https://s3.sa-east-1.amazonaws.com/assets.broadfactor.com/customer-dashboard-front/assets/svg/Broadfactor+Logo+-+Colorido+%5BLetra+preta%5D.svg"
    alt="Logo da Broadfactor"
    class="header-img"
  />
  <img
    src="https://s3.sa-east-1.amazonaws.com/assets.broadfactor.com/customer-dashboard-front/assets/svg/close.svg"
    alt="Icone de Fechar"
    mat-dialog-close
    style="cursor: pointer"
  />
</header>

<mat-dialog-content class="mat-typography box">
  <p class="box-description">
    O processo se divide em 4 etapas. Veja o que acontece em cada uma delas
    abaixo:
  </p>

  <section class="box-main">
    @for (step of dataSteps; track step.title){
    <mat-card class="box-main-card">
      <mat-card-header class="box-main-card-header">
        <h1 class="box-main-card-header-title">{{ step.title }}</h1>
        <h3 class="box-main-card-header-subtitle">
          | {{ step.subtitle }}
        </h3>
      </mat-card-header>

      <figure class="box-main-card-image">
        <img mat-card-image [src]="step.img" alt="#" />
      </figure>

      <mat-card-content class="box-main-card-content">
        <p class="box-main-card-content-mainDescription">
          {{ step.shortDescription }}
        </p>
        @for (topic of step.description; track topic){
        <div class="box-main-card-content-item">
          <div class="box-main-card-content-item-icon">
            <mat-icon>check</mat-icon>
          </div>
          <p [innerHTML]="formatDescription(topic)"></p>
        </div>
        }
      </mat-card-content> </mat-card
    >}
  </section>
</mat-dialog-content>
